import { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Row, Col, Typography, List, Spin } from 'antd';
import { CheckSquareTwoTone, ExclamationCircleTwoTone } from '@ant-design/icons';
import systemActions from '../../redux/systemInfos/actions';
import IntlMessages from '../../components/utility/intlMessages';
import Box from '../../components/utility/box';

const { Title } = Typography;

const { getDatabases } = systemActions;

function Databases(props) {
  useEffect(() => {
    props.getDatabases();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const databaseListItemFactory = record => {
    const getStatusIcon = (status) => {
      return status === "available"
        ? <CheckSquareTwoTone twoToneColor="#52c41a" style={{ fontSize: "20px" }} />
        : <ExclamationCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "20px" }} />;
    }

    return (
      <List.Item>
        <Row style={{ width: "100%" }} gutter={[16,16]}>
          <Col xs={24} md={6} lg={8} xl={8} style={{ wordWrap: "break-word" }}>
            <IntlMessages id="databases.dbName" />: {record?.name}
          </Col>
          <Col xs={24} md={5} lg={3} xl={3}>
            <IntlMessages id="databases.status" />: {getStatusIcon(record?.status)}
          </Col>
          <Col xs={24} md={4} lg={4} xl={4}>
            <IntlMessages id="databases.type" />: {record?.type}
          </Col>
          <Col xs={24} md={6} lg={6} xl={6} style={{ wordWrap: "break-word" }}>
            <IntlMessages id="databases.latestRestorableTime" />: {record?.latestRestorableTime ?? "-"}
          </Col>
          <Col xs={24} md={3} lg={3} xl={3}>
            <a href={record?.awsLink} target="_blank" rel="noreferrer" ><IntlMessages id="databases.awsLink" /></a>
          </Col>
        </Row>
      </List.Item>
    );
  }


  return (
    <Spin spinning={props.loading > 0}>
      <Box>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Title level={4} style={{ textAlign: "center" }}>
              <IntlMessages id="databases.title" />
            </Title>
            <List
              style={{ maxHeight: "700px", overflowY: 'auto' }}
              bordered
              dataSource={props.data}
              renderItem={databaseListItemFactory}
            />
          </Col>
        </Row>
      </Box>
    </Spin>
  )
}

Databases.propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.number.isRequired,

  getDatabases: PropTypes.func.isRequired,
};

Databases.defaultProps = {
  data: [],
}

const mapActionsToProps = {
  getDatabases,
};

function mapStateToProps(state) {
  return {
    loading: state.SystemInfos.get('loading'),
    data: state.SystemInfos.get('databasesData')
  };
}

const connectedDatabases = connect(mapStateToProps, mapActionsToProps)(Databases);
export default connectedDatabases;